<template>
  <pre class="mb-7 rounded bg-slate-100 p-4 text-sm last:mb-0 md:p-8 md:text-lg">
    <code>
      <slot />
    </code>
  </pre>
</template>
